module.exports = __webpack_public_path__ + "fa806d8f6259a6329f1c446f6647aeb7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/shoes-clown.png
// module id = 2426
// module chunks = 0